import { memo, useEffect, useState } from 'react';
import classNames from 'classnames';
import { PayedReponse } from '@/types';

interface IProps {
    orderRecords: PayedReponse[];
    noData: boolean;
    initPayedList: () => void;
}

const BuyRecords = ({ orderRecords, noData, initPayedList }: IProps) => {
    const [isScroll, setScroll] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleInit = () => {
        initPayedList();
        setLoading(true);
        setTimeout(() => setLoading(false), 1000);
    };

    const handleScroll = async e => {
        setScroll(e.target.scrollTop > 8 ? true : false);
    };

    useEffect(() => {
        if (!orderRecords.length) setScroll(false);
    }, [orderRecords]);

    return (
        <div className="rights-list-box">
            <div className={classNames('rights-pay-title', { 'handle-scroll': isScroll })}>
                <div>
                    <img src="http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202406/06/2be7c_20240606104224.png" />
                    购买记录
                </div>
                <span className={loading ? 'update-time rotate-loading' : 'update-time'} onClick={handleInit} />
            </div>
            {!!orderRecords.length && (
                <div className="scroll-box" onScroll={handleScroll}>
                    {orderRecords.map((item, i) => (
                        <div key={Date.now() + String(i)} className="pay-item">
                            <div className="pay-name">{item.equityTitle}</div>
                            <div className="pay-tips">luca答疑次数：{item.lucaAskNumStr}</div>
                            <div className="pay-tips">名师答疑次数：{item.teacherAskNumStr}</div>
                            {item.aiCorrectNumStr && <div className="pay-tips">智能批改次数：{item.aiCorrectNumStr}</div>}
                            {item.manualCorrectNumStr && <div className="pay-tips">人工批改次数：{item.manualCorrectNumStr}</div>}
                            <div className="pay-tips">有效期至：{item.expireDate}</div>
                            <div className="pay-money">
                                ¥ <span>{item.amount}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            {noData && (
                <div className="empty-box">
                    <img src="http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202406/06/619d2_20240606093432.png" />
                </div>
            )}
        </div>
    );
};

export default memo(BuyRecords);
